import React from 'react';
import { BarChart, Loading } from '@dsi/react-eds';
import { ColorScale } from '@eds/vanilla';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import styles from './TestExecutionStatusByProductLine.module.css';
import { TestExecutionDashboard } from '../interfaces/text-execution-dashboard.interface';

interface TestExecutionStatusByProductLineProps {
  startDate: string;
  endDate: string;
  data: TestExecutionDashboard[];
  isLoading: boolean;
  isError: boolean;
}

const TestExecutionStatusByProductLine: React.FC<TestExecutionStatusByProductLineProps> = ({
  startDate,
  endDate,
  data,
  isLoading,
  isError
}) => {
  const chartKey = `${startDate}-${endDate}`;

  const status = ['Success', 'Warning', 'Failure'];

  return (
    <div>
      {isLoading && (
        <div className={styles.loadingContainer}>
          <ReactEDSWrapper component={Loading} size="large" />
        </div>
      )}
      {isError && <div className={styles.loadingText}>Error while loading test executions per product line data.</div>}

      {!isLoading &&
        !isError &&
        data &&
        (() => {
          if (data.length === 0) {
            return (
              <div className={styles.noDataContainer}>
                <i className={`icon icon-failed ${styles.dangerIcon}`} />
                <div className={styles.noDataTitle}>Data Unavailable</div>
                <div className={styles.noDataSubtitle}>No test executions per product line data available for the selected time range</div>
              </div>
            );
          }

          const seriesData = status.map((s: string) => {
            return { name: s, values: data.map((d: TestExecutionDashboard) => +d[s.toLowerCase() ?? 0]) };
          });
          const chartData = {
            common: data.map((s: TestExecutionDashboard) => {
              return s.product_line;
            }),
            series: seriesData
          };
          const colorScale = new ColorScale({ data: chartData, colors: ['color-green', 'color-orange', 'color-red'] });
          return (
            <div className={styles.chartContainer}>
              <ReactEDSWrapper
                key={chartKey}
                component={BarChart}
                id={`test-execution-status-by-product-line-${chartKey}`}
                data={chartData}
                y={{ unit: 'Executions' }}
                vertical
                barWidth={15}
                height={300}
                stacked={true}
                colorScale={colorScale}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default TestExecutionStatusByProductLine;
